import { registerRendererGroup, registerToolRendererGroup, ShapeFunctions } from "../../util/shapeCategorySingleton";
import { createPolygonRubber, globalPolygon, polygonIntersectWithRect, transformPolygonToInternalShape } from "./Polygon";
import createDefaultPropertyPalette from "../polygon/PolygonDefaultProperyPalette";
import createPropertyPalette from "../polygon/PolygonProperyPalette";
import { createPolygon, polygonBoundingboxCalculation } from "./Polygon";
import { createPolygonBase } from "./PolygonBase";

const polygonFunctions: ShapeFunctions = {
  shapeRendererGroup: {
    shapeRender: createPolygon,
    rubberlineRender: createPolygonRubber,
    baseShapeRenderer: createPolygonBase,
  },
  shapeTransformerGroup: {
    snapPointCalculator: (s: GeometricShape) => s,
    rectangleIntersectCheck: (s: GeometricShape, r: RectSel) => {
      return polygonIntersectWithRect(s, r);
    },
    globalShapeTransformer: globalPolygon,
    transformToInternalShape: transformPolygonToInternalShape,
    calculateWidthHeight: polygonBoundingboxCalculation,
  },
  UIElementRender: {
    propertyPaletteRenderer: createPropertyPalette,
    defaultPropertyPaletteRenderer: createDefaultPropertyPalette,
  },
}

registerRendererGroup("polygon", polygonFunctions);
registerToolRendererGroup("polygon", { toolRender: createPolygonRubber });